import { KendoSortDescriptor } from '@ui/aos-lib';

import { OrderDirection } from 'src/app/pages/equipment/devices/components/devices.models';
import {
  ConsumptionAnalyticsFieldName,
  ConsumptionAnalyticsTableColumnName
} from './individual-consumption-table.types';
import { mapTableSortToPayloadSort } from '@portal/shared/components/listing-page/helpers/map-sort-descriptor-to-sorting-state.helper';

export function mapSortDescriptorToPayloadSorting(sortDescriptor: KendoSortDescriptor): {
  columnName: ConsumptionAnalyticsFieldName;
  orderDirection: OrderDirection;
} {
  return {
    columnName: {
      [ConsumptionAnalyticsTableColumnName.TotalValue]: ConsumptionAnalyticsFieldName.TotalValue,
      [ConsumptionAnalyticsTableColumnName.AverageValue]: ConsumptionAnalyticsFieldName.AverageValue,
      [ConsumptionAnalyticsTableColumnName.MaximumValue]: ConsumptionAnalyticsFieldName.MaximumValue,
      [ConsumptionAnalyticsTableColumnName.MinimumValue]: ConsumptionAnalyticsFieldName.MinimumValue
    }[sortDescriptor.field]!,
    orderDirection: mapTableSortToPayloadSort(sortDescriptor)
  };
}
